<template>
  <div id="new_user" @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>登録情報入力</h2>
          <label>下記フォームより入力してください。</label>
        </div>
        <dd-user-input
          ref="userInputRef"
          :isEdit="true"
          :userForm="userForm"
        />
        <div id="regist_btn">
          <button class="main_btn" @click="update()">登録する</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
// import * as Check from '../../utils/Check'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
// import {CORP_TYPE, INFO_SRC} from '../constants/TypeEc'

// Module
import Header from '../components/common/DcHeader'
import UserInput from '../components/user/UserInput'

export default {
  name: 'RegistUserConfirm',
  components: {
    'dd-header': Header,
    'dd-user-input': UserInput
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      userForm: {
        corpType: '',
        corpName: '',
        corpBranchName: '',
        corpDept: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        tel: '',
        fax: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        infosrc: '',
        recvInfo: false,
        consent: false
      },
      isEdit: false,
      errors: {},
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        email: ''
      }
    }
  },
  computed: {
  },
  methods: {
    update: function () {
      let ret = this.$refs.userInputRef.confirm()
      if (!ret) return

      // DBに登録する
      let payload = {
        corpType: this.userForm.corpType,
        corpName: this.userForm.corpName,
        corpBranchName: this.userForm.corpBranchName,
        corpDept: this.userForm.corpDept,
        userLastName: this.userForm.userLastName,
        userFirstName: this.userForm.userFirstName,
        userLastNameKana: this.userForm.userLastNameKana,
        userFirstNameKana: this.userForm.userFirstNameKana,
        tel: this.userForm.tel,
        fax: this.userForm.fax,
        postcd: this.userForm.postcd,
        state: this.userForm.state,
        city: this.userForm.city,
        street: this.userForm.street,
        infosrc: this.userForm.infosrc,
        inviteCode: this.userForm.inviteCode,
        recvInfo: this.userForm.recvInfo
      }
      axios.post(DC_URL.USER + '/update-user', payload
      ).then(response => {
        if (response.data.errorMessage) {
          this.fieldErrorMessages.email = response.data.errorMessage
          this.$refs.userInputRef.setErrorMessage(this.fieldErrorMessages)
        } else {
          // 更新データをストレージに格納する
          App.setLocalStorage(DC_STORAGE_KEY.USER_DATA, this.userForm)
          this.$router.push({
            name: 'UpdateUserConfirm',
            params: {
              userForm: this.userForm
            }
          })
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    fetchData: function () {
      this.userForm = App.getLocalStorage(DC_STORAGE_KEY.USER_DATA)
    },
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/UpdateUserInput.vue